import React, { useState, useEffect } from 'react';
import {Layout, Menu, theme, Button} from 'antd';
import {
    UserOutlined,
    SettingOutlined,
    TeamOutlined,
    LockOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';

const { Sider } = Layout;

const SideMenu = ({ onCollapse }) => {
    const {
        token: { colorBgContainer },
    } = theme.useToken();
    const navigate = useNavigate();
    const location = useLocation();
    const currentUser = authService.getCurrentUser();

    const [collapsed, setCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [mobileSiderVisible, setMobileSiderVisible] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        if (onCollapse) {
            onCollapse(collapsed);
        }
    }, [collapsed, onCollapse]);

    const getSelectedKey = () => {
        const path = location.pathname;
        if (path === '/') return ['profile'];
        if (path.startsWith('/users')) return ['users-list'];
        if (path.startsWith('/auth-attempts-logs')) return ['auth-attempts-logs'];
        if (path.startsWith('/auth-block-logs')) return ['auth-block-logs'];
        if (path.startsWith('/security')) return ['security'];
        return [];
    };

    const toggleCollapsed = () => {
        isMobile ? setMobileSiderVisible(!mobileSiderVisible) : setCollapsed(!collapsed);
    };

    const menuItems = [
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: 'Профиль',
            onClick: () => navigate('/'),
        },
        {
            key: 'security',
            icon: <LockOutlined />,
            label: 'Безопасность',
            onClick: () => navigate('/security'),
        },
        currentUser?.role === 'admin' && {
            key: 'admin',
            icon: <TeamOutlined />,
            label: 'Администрирование',
            children: [
                {
                    key: 'users-list',
                    icon: <TeamOutlined />,
                    label: 'Пользователи',
                    onClick: () => navigate('/users'),
                },
                ,
                {
                    key: 'auth-attempts-logs',
                    icon: <LockOutlined />,
                    label: 'Логи авторизации',
                    onClick: () => navigate('/auth-attempts-logs'),
                },
                {
                    key: 'auth-block-logs',
                    icon: <LockOutlined />,
                    label: 'Логи блокировок',
                    onClick: () => navigate('/auth-block-logs'),
                },
            ],
        },
    ].filter(Boolean);

    if (isMobile) {
        return (
            <>
                <Button
                    type="primary"
                    onClick={toggleCollapsed}
                    style={{ position: 'fixed', right: 24, bottom: 24, zIndex: 1001 }}
                    icon={mobileSiderVisible ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
                />
                {mobileSiderVisible && (
                    <div
                        style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.45)', zIndex: 999 }}
                        onClick={() => setMobileSiderVisible(false)}
                    />
                )}
                <Sider
                    width={250}
                    style={{ background: colorBgContainer, overflow: 'auto', height: '100vh', position: 'fixed', left: mobileSiderVisible ? 0 : -250, transition: 'all 0.2s', zIndex: 1000 }}
                >
                    <Menu mode="inline" selectedKeys={getSelectedKey()} items={menuItems} style={{padding: '8px'}}/>
                </Sider>
            </>
        );
    }

    return (
        <Sider width={260} collapsible collapsed={collapsed} trigger={null} collapsedWidth={80} style={{ background: colorBgContainer, overflow: 'auto', height: 'calc(100vh - 64px)', position: 'fixed', left: 0, top: 64 }}>
            <Menu mode="inline" selectedKeys={getSelectedKey()} items={menuItems}  style={{padding: '8px'}}/>
            <div style={{ position: 'absolute', bottom: 0, width: '100%', padding: '12px', textAlign: 'right', borderTop: '1px solid rgba(139, 139, 139, 0.35)' }}>
                <Button type="text" onClick={toggleCollapsed} icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} />
            </div>
        </Sider>
    );
};

export default SideMenu;
